import {
  createSlice,
  type PayloadAction,
} from '@reduxjs/toolkit';
import {
  tournamentsApiSlice,
} from '../api';
import {
  type TournamentCategory,
  type TournamentsState,
} from './types';

const initialState: TournamentsState = {
  categories: [],
  currentCategory: null,
  activeTournaments: [],
  privateTournaments: [],
  pendingTournaments: [],
  tournamentsLeaderboardList: [],
  tournamentListByCategories: [],
  tournamentLeaderboardListByCategories: [],
};

export const tournamentsSlice = createSlice({
  name: 'tournaments',
  initialState,
  reducers: {
    setCurrentCategory: (state: TournamentsState, action: PayloadAction<TournamentCategory>) => {
      state.currentCategory = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addMatcher(
      tournamentsApiSlice.endpoints.getTournamentsWithCategories.matchFulfilled,
      (state, action) => {
        state.categories = action.payload.categories;
        state.currentCategory = action.payload.categories[0];
        state.tournamentListByCategories = action.payload.tournamentList;
        state.tournamentLeaderboardListByCategories = action.payload.tournamentLeaderboardList;
      });
    builder.addMatcher(
      tournamentsApiSlice.endpoints.getTournamentsWithRanking.matchFulfilled,
      (state, action) => {
        state.activeTournaments = action.payload.activeTournaments;
        state.pendingTournaments = action.payload.pendingTournaments;
        state.privateTournaments = action.payload.privateTournamentList;
        state.tournamentsLeaderboardList = action.payload.tournamentsLeaderboardList;
      });
  },
});

export const { setCurrentCategory } = tournamentsSlice.actions;
export const tournamentsReducer = tournamentsSlice.reducer;
